export enum PageErrorType {
  Unauthorized = 'Unauthorized',
  NotFound = 'NotFound',
  GeneralError = 'GeneralError',
  // TODO: Can build on top of this to handle more specific errors
}
